import React from "react";

import { makeStyles } from "@material-ui/core/styles";

import LegendItem from "./LegendItem";


const useStyles = makeStyles((theme) => ({
  legend: {
    padding: theme.spacing(0.5),
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    color: theme.palette.text.secondary,
    ...theme.typography.body2,
    "& > *": {
      margin: theme.spacing(0.5),
      padding: theme.spacing(0),
    },
  },
}));

const MobilityLegend = React.memo(({ disabledLines, lines, onToggleLine }) => {
  const classes = useStyles();

  return (
    <div className={classes.legend}>
      {lines.map(({ name, id, color }) => (
        <LegendItem clickable key={id} label={name} color={color} disabled={!!disabledLines[id]} onClick={() => onToggleLine(id)}/>
      ))}
    </div>
  );
});


export default MobilityLegend;